const Config = Object.entries(process.env).reduce((config, [key, value]) => {
	const [, prop] = key.match(/^REACT_APP_(.+)/) || [];
	if (prop) {
		config[prop] = value;
	}
	return config;
}, {});

export default Config;
